






















































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class GroupView extends Vue {
  public items: Common.PartneredUser[] = new Array();
  public params: Common.PartneredUserQuery = new Common.PartneredUserQuery();
  public exportQuery = new Common.ExportQuery('顧問先アクセス管理', this.params);

  public sortOptions: any = [
    { value: 'tenantid', text: 'テナントID' },
    { value: 'tenantname', text: 'テナント' },
    { value: 'userid', text: 'ユーザーID' },
    { value: 'username', text: 'ユーザー' },
  ];


  public created(){
    this.$api.formatter.ensureListLoaded('partneredTenantList');
  }  
  public onCreated(listView:any){
    listView.onExec = this.onExec;
  }
  // 追加時の動作
  public async onExec(item: any) {
    
    var query = new Common.PartneredUserCreateQuery();
    query.tenantId = item.tenantId;
    query.userId = item.userId;
    return this.$api.execute(query).then(res=>{
    let listView = (this.$refs.mainList as Components.ListView);
    listView.isInsertMode = false;
    listView.isEditting = false;
    if (listView.fullSizeEditor == false) {
      listView.sideEditor.setState(Common.editorStates.Read);
    } else {
      //フルサイズエディタの表示
      listView.editor.setState(Common.editorStates.Read);
    }
      listView.reload();
      return true;
    }).catch(()=>{return false;});
  }
  public async onDelete(){
    var selectedItems =  (this.$refs.mainList as Components.ListView).selectedItems;
    return this.$api.modal.showDialog('確認メッセージ', selectedItems.length + '件のデータを本当に削除してよろしいですか?', false)
        .then(() => {
          this.$api.startWaitCusor();
          return this.$api.execute(new Common.PartneredUserDeleteQuery(selectedItems)).finally(()=>this.$api.closeWaitCursor());
        });
  }
  //テナントに遷移
  public onClick(tenantId:string){        
    if (this.$api.enviromentFlag == Common.enviromentFlags.production) window.open(String.format("https://{0}.s-flow.net",tenantId), '_blank');       
    else window.open(String.format("https://{0}.s-flow-stage.net",tenantId), '_blank');                     
  }
}
